<template>
    <div class="about-page">
      <top-nav :showLogo="true" />
      <h1>About Page</h1>
      <p>This is the about page content.</p>
    </div>
  </template>
  
  <script>
  import TopNav from '@/components/TopNav.vue';
  
  export default {
    name: 'AboutPage',
    components: {
      TopNav
    }
  }
  </script>
  
  <style scoped>
  .about-page {
    padding: 2rem;
    font-family: 'Playfair Display', Georgia, serif;
  }
  </style>
  